import React from 'react';
import {
  AfterTheSwitch,
  AfterTheSwitchProps,
} from '@kizi/comparator-components';
import { useField, TriplePlayHowItWorks } from '@kizi/comparator-core';
import { TimelineItemProps } from '@kizi/shared-components';

interface HowItWorksWrapperProps extends AfterTheSwitchProps {
  selectedProduct: string;
}

const Titles = {
  ['How it works-affiliate']: 'Aanvraag op de website van verzekeraar',
  ['How it works-confirmation_cb']: 'Bevestiging Consumentenbond',
  ['How it works-cancel_old']: 'Opzeggen oude verzekering',
  ['How it works-service']: 'Overstapservice',
  ['How it works-delivery']: 'Afspraak levering & installatie',
};

function getStep(step: TriplePlayHowItWorks, name?: string): TimelineItemProps {
  if (step.typeName === 'How it works-confirmation_company') {
    return {
      title: `Bevestiging ${name}`,
      body: step.value,
    };
  }

  return {
    title: Titles[step.typeName],
    body: step.value,
  };
}

export const HowItWorksWrapper = React.memo<HowItWorksWrapperProps>(
  ({ selectedProduct, ...props }) => {
    const selectedProductField = useField(selectedProduct);
    const data = JSON.parse(selectedProductField?.value as string);
    const howItWorks = data.provider.howItWorks;

    if (!howItWorks) return null;
    const steps = howItWorks.map((step) => getStep(step, data.provider.name));

    return <AfterTheSwitch {...props} steps={steps} />;
  },
);
